import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "1. Responsable du traitement",
    body: [
      "Helencia Maison (contact : hello@helencia.fr) est responsable du traitement des données personnelles collectées sur la plateforme helencia.fr.",
    ],
  },
  {
    heading: "2. Données collectées",
    body: [
      "Lors de l'inscription et de l'utilisation de Helencia, nous collectons les données suivantes :",
      [
        "Identité : nom, prénom, email (via Google OAuth).",
        "Profil : type de talent, ville, biographie, disponibilités, photos de portfolio.",
        "Données professionnelles : nom d'entreprise, secteur, description (pour les comptes pros).",
        "Données transactionnelles : abonnements Premium, paiements Stripe (identifiants de session, statut de paiement).",
        "Données techniques : logs de connexion, adresse IP, navigateur.",
      ],
    ],
  },
  {
    heading: "3. Finalités du traitement",
    body: [
      "Vos données sont traitées pour :",
      [
        "Fournir le service (création du profil, candidatures, publications).",
        "Permettre la mise en relation entre talents et professionnels.",
        "Gérer les abonnements Premium et les paiements.",
        "Vous envoyer des notifications liées à votre activité sur la plateforme.",
        "Améliorer la qualité du service via des statistiques anonymisées.",
      ],
    ],
  },
  {
    heading: "4. Base légale",
    body: [
      "Le traitement est fondé sur votre consentement (inscription volontaire), l'exécution du contrat (prestations Premium) et l'intérêt légitime de Helencia (sécurité, prévention des fraudes).",
    ],
  },
  {
    heading: "5. Durée de conservation",
    body: [
      "Vos données sont conservées tant que votre compte est actif. En cas de suppression de compte, vos données sont effacées sous 30 jours, à l'exception des données comptables (factures Premium) conservées 10 ans conformément à la loi.",
    ],
  },
  {
    heading: "6. Destinataires",
    body: [
      "Vos données ne sont jamais vendues. Elles sont uniquement partagées avec :",
      [
        "Les professionnels auxquels vous postulez (portfolio et profil public).",
        "Nos sous-traitants techniques : Stripe (paiements), Google OAuth (authentification), MongoDB Atlas (hébergement).",
      ],
    ],
  },
  {
    heading: "7. Vos droits",
    body: [
      "Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, de suppression, de portabilité, d'opposition et de limitation du traitement.",
      "Pour exercer ces droits : envoyez un email à privacy@helencia.fr en précisant votre demande et un justificatif d'identité.",
      "Vous disposez également du droit d'introduire une réclamation auprès de la CNIL (www.cnil.fr).",
    ],
  },
  {
    heading: "8. Cookies",
    body: [
      "Helencia utilise uniquement des cookies strictement nécessaires au fonctionnement du service (session d'authentification). Aucun cookie publicitaire ou de tracking marketing tiers n'est déployé.",
    ],
  },
  {
    heading: "9. Sécurité",
    body: [
      "Vos données sont chiffrées en transit (HTTPS / TLS) et au repos. Les paiements sont gérés exclusivement par Stripe (certifié PCI-DSS niveau 1) — Helencia ne stocke aucune donnée bancaire.",
    ],
  },
];

export default function Confidentialite() {
  return <LegalPage title="Politique de confidentialité" sections={SECTIONS} testid="confidentialite-page" />;
}
